import type { CredentialType } from "@/features/credentials/models/credential";
import type { TFunction } from "i18next";

export function formatCredentialType(credentialType: CredentialType, t: TFunction): string {
  switch (credentialType) {
    case "ENTITY":
      return t("user.type.team");
    case "VENUE":
      return t("user.type.venue");
    case "ALL":
      return t("user.type.all");
    default:
      return credentialType;
  }
}
